/* tslint:disable */
/* eslint-disable */
/**
 * authentik
 * Making authentication simple.
 *
 * The version of the OpenAPI document: 2024.12.3
 * Contact: hello@goauthentik.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UiThemeEnumFromJSON, } from './UiThemeEnum';
import { FooterLinkFromJSON, } from './FooterLink';
/**
 * Check if a given object implements the CurrentBrand interface.
 */
export function instanceOfCurrentBrand(value) {
    if (!('matchedDomain' in value) || value['matchedDomain'] === undefined)
        return false;
    if (!('brandingTitle' in value) || value['brandingTitle'] === undefined)
        return false;
    if (!('brandingLogo' in value) || value['brandingLogo'] === undefined)
        return false;
    if (!('brandingFavicon' in value) || value['brandingFavicon'] === undefined)
        return false;
    if (!('uiFooterLinks' in value) || value['uiFooterLinks'] === undefined)
        return false;
    if (!('uiTheme' in value) || value['uiTheme'] === undefined)
        return false;
    if (!('defaultLocale' in value) || value['defaultLocale'] === undefined)
        return false;
    return true;
}
export function CurrentBrandFromJSON(json) {
    return CurrentBrandFromJSONTyped(json, false);
}
export function CurrentBrandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'matchedDomain': json['matched_domain'],
        'brandingTitle': json['branding_title'],
        'brandingLogo': json['branding_logo'],
        'brandingFavicon': json['branding_favicon'],
        'uiFooterLinks': (json['ui_footer_links'].map(FooterLinkFromJSON)),
        'uiTheme': UiThemeEnumFromJSON(json['ui_theme']),
        'flowAuthentication': json['flow_authentication'] == null ? undefined : json['flow_authentication'],
        'flowInvalidation': json['flow_invalidation'] == null ? undefined : json['flow_invalidation'],
        'flowRecovery': json['flow_recovery'] == null ? undefined : json['flow_recovery'],
        'flowUnenrollment': json['flow_unenrollment'] == null ? undefined : json['flow_unenrollment'],
        'flowUserSettings': json['flow_user_settings'] == null ? undefined : json['flow_user_settings'],
        'flowDeviceCode': json['flow_device_code'] == null ? undefined : json['flow_device_code'],
        'defaultLocale': json['default_locale'],
    };
}
export function CurrentBrandToJSON(json) {
    return CurrentBrandToJSONTyped(json, false);
}
export function CurrentBrandToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'matched_domain': value['matchedDomain'],
        'branding_title': value['brandingTitle'],
        'branding_logo': value['brandingLogo'],
        'branding_favicon': value['brandingFavicon'],
        'flow_authentication': value['flowAuthentication'],
        'flow_invalidation': value['flowInvalidation'],
        'flow_recovery': value['flowRecovery'],
        'flow_unenrollment': value['flowUnenrollment'],
        'flow_user_settings': value['flowUserSettings'],
        'flow_device_code': value['flowDeviceCode'],
    };
}
